var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.33333H14",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 3.99992V2.66659C5.33398 2.31296 5.47446 1.97382 5.72451 1.72378C5.97456 1.47373 6.3137 1.33325 6.66732 1.33325H9.33398C9.68761 1.33325 10.0267 1.47373 10.2768 1.72378C10.5268 1.97382 10.6673 2.31296 10.6673 2.66659V3.99992M12.6673 3.99992V13.3333C12.6673 13.6869 12.5268 14.026 12.2768 14.2761C12.0267 14.5261 11.6876 14.6666 11.334 14.6666H4.66732C4.3137 14.6666 3.97456 14.5261 3.72451 14.2761C3.47446 14.026 3.33398 13.6869 3.33398 13.3333V3.99992H12.6673Z",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.33325V11.3333",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 7.33325V11.3333",
    stroke: "#2C303B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDark);
export default __webpack_public_path__ + "static/media/trash-dark.03757121917aa37b0d23750cded14573.svg";
export { ForwardRef as ReactComponent };